

import {userGuard} from '@/router/guard'
/*
  menu:控制台右侧菜单栏归属
  breadcrumb:面包屑 title || 数组
  menuBreadcrumb：数组面包屑，menu归属
*/
const routes = [
  {
    path: '/console',
    redirect: 'appLink/app/list'
  },
  {
    path: 'appLink/app/list',
    name: 'appList',
    meta: {
      title:'统一链接管理',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList'],
      key: 'appList',
      keepAlive: true,
    },
    component: () => import('@/views/console/appLink/app/List.vue'),
  },
  {
    path: 'appLink/app/form',
    name: 'appForm',
    meta: {
      title:'创建应用',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','appForm'],
      key: 'appForm',
    },
    component: () => import('@/views/console/appLink/app/Form.vue'),
    beforeEnter: (to, from, next) => userGuard(to, from, next) && next(),
  },
  {
    path: 'appLink/app/appData',
    name: 'appData',
    meta: {
      title:'应用数据',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','appForm'],
      key: 'appForm',
    },
    component: () => import('@/views/console/appLink/app/appData.vue'),
    beforeEnter: (to, from, next) => userGuard(to, from, next) && next(),
  },
  {
    path: 'appLink/link/List',
    name: 'linkList',
    meta: {
      title:[],//此页面面包屑采用下拉选项
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','linkList'],
      key: 'linkList',
      // keepAlive: true,
    }, 
    component: () => import('@/views/console/appLink/link/List.vue'),
  },
  {
    path: 'appLink/link/form',
    name: 'linkForm',
    meta: {
      title:'创建链接',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','linkList','linkForm'],
      key: 'linkForm',
    }, 
    component: () => import('@/views/console/appLink/link/Form.vue'),
  },
  {
    path: 'appLink/link/info',
    name: 'linkInfo',
    meta: {
      title:'链接详情',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','linkList','linkInfo'],
      key: 'linkInfo',
    }, 
    component: () => import('@/views/console/appLink/link/Info.vue'),
  },
  {
    path: 'appLink/link/edit',
    name: 'linkEdit',
    meta: {
      title:'编辑参数',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','linkList','linkEdit'],
      key: 'linkEdit',
    }, 
    component: () => import('@/views/console/appLink/link/Edit.vue'),
  },
  {
    path: 'appLink/link/modifyParamList',
    name: 'modifyParamList',
    meta: {
      title:'修改参数',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','linkList','modifyParamList'],
      key: 'modifyParamList',
    }, 
    component: () => import('@/views/console/appLink/link/template/modifyParamList.vue'),
  },
  {
    path: 'appLink/link/modify',
    name: 'linkModify',
    meta: {
      title:'修改参数',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','linkList','linkModify'],
      key: 'linkModify',
    }, 
    component: () => import('@/views/console/appLink/link/modify.vue'),
  },
  {
    path: 'appLink/link/reviseInfo',
    name: 'reviseInfo',
    meta: {
      title:'修改参数详情',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','linkList','reviseInfo'],
      key: 'reviseInfo',
    }, 
    component: () => import('@/views/console/appLink/link/reviseInfo.vue'),
  },
  {
    path: 'appLink/link/linkData',
    name: 'linkData',
    meta: {
      title:'链接数据',
      menu: '/console/appLink/app/list',
      breadcrumb:['appList','linkList','linkData'],
      key: 'linkData',
    }, 
    component: () => import('@/views/console/appLink/link/linkData.vue'),
  },
]


export default routes;
